import { DialogContainer } from "@/components/dialog-container";
import { Button } from "@/components/ui/button";
import { CircleCheckFilled } from "@/lib/icons/circle-check-filled";
import { useLocation } from "wouter";
import { ForgotPasswordDialogProps } from "../forgot-password.types";

export function ForgotPasswordDialog({ open, setOpen }: ForgotPasswordDialogProps) {
  const [_, navigate] = useLocation();
  
  return (
    <DialogContainer
      open={open}
      onOpenChange={setOpen}
      title={""}
      children={
        <div className="flex flex-col items-center gap-2" >
          <CircleCheckFilled className="text-primary" size={40} />

          <div className="text-center" >
            <span className="text-black text-2xl font-bold" >
              Solicitação de redefinir
            </span>
            <p className="text-black text-2xl font-bold" >
              senha enviada
            </p>
          </div>

          <p className="text-gray-600 text-md" >
            Acesse o seu e - mail cadastrado e altera a sua senha.
          </p>

          <Button type="button" onClick={() => navigate("/login")}>
            Ir para o Login 
          </Button>
        </div>
      }
    />
  )
}